import React from 'react';

export default ({ anchor_name }) => {
  if(!anchor_name) return null;

  const slug = anchor_name.toLowerCase().replace(/\s/g, '-').concat('-anchor-link');
  return <i className={'anchor-link'} id={slug} data-name={anchor_name} />;
}
